import { render } from "./StartProjectForm.vue?vue&type=template&id=3b0a6a20"
import script from "./StartProjectForm.vue?vue&type=script&lang=js"
export * from "./StartProjectForm.vue?vue&type=script&lang=js"

import "./StartProjectForm.vue?vue&type=style&index=0&id=3b0a6a20&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__